module.exports = __webpack_public_path__ + "img/empty-black-white.4b95b1b2.png";